import { Briefcase, Goal, User } from "assets/icons";
import { Button } from "components/button/Button";
import { Star } from "components/inclusion/components/Star";
import { FC } from "react";
import { i18nService } from "services";
import { ITussendoortjesRow } from "../types";
import { NewCircle } from "components/inclusion/components/NewCircle";

interface Props {
  row: ITussendoortjesRow;
  rowIndex: number;
  expandedRowTitle: string | null;
  toggleRow: (title: string) => void;
  favorites?: string[];
  addToFavorites: (t: string) => void;
  removeFromFavorites: (t: string) => void;
}

export const renderDifficulty = (difficulty: number) => {
  switch (difficulty) {
    case 1:
      return "Makkelijk";
    case 2:
      return "Gemiddeld";
    case 3:
      return "Moeilijk";
    default:
      return "Onbekend";
  }
};

const addProtocolToUrl = (url: string): string => {
  if (url.startsWith("https://")) {
    return url;
  } else {
    return `https://${url}`;
  }
};

export const TussendoortjesTableRow: FC<Props> = ({
  row: {
    title,
    themes,
    difficulty,
    goals,
    learning_areas,
    key_competencies,
    description,
    cta_link,
    spotlight,
  },
  rowIndex,
  expandedRowTitle,
  toggleRow,
  favorites,
  addToFavorites,
  removeFromFavorites,
}) => {
  return (
    <>
      <tr
        key={rowIndex}
        className="table-overview__row"
        aria-label={`${i18nService.copy["table.openRow"]} ${rowIndex + 1}`}
        aria-controls={`${rowIndex}_desc`}
      >
        <td>
          <Star
            ariaLabel={i18nService.copy["table.addFavorite"]}
            filled={favorites && favorites.includes(title)}
            onClick={() => {
              favorites && favorites.includes(title)
                ? removeFromFavorites(title)
                : addToFavorites(title);
            }}
            tabIndex={0}
          />
        </td>
        <td
          className="table-overview__row__title"
          onClick={() => toggleRow(title)}
        >
          {spotlight && <NewCircle label="Nieuw" size="small" />}
          {title}
        </td>
        <td onClick={() => toggleRow(title)}>{themes?.join(", ")}</td>
        <td onClick={() => toggleRow(title)}>{renderDifficulty(difficulty)}</td>
        <td onClick={() => toggleRow(title)}>
          {description && (
            <button
              className={`table-overview__open ${
                expandedRowTitle === title && "is-open"
              }`}
              aria-label={`${i18nService.copy["table.openRow"]} ${
                rowIndex + 1
              }`}
              aria-expanded={expandedRowTitle === title}
            ></button>
          )}
        </td>
      </tr>
      {expandedRowTitle === title && description && (
        <tr id={`${rowIndex}_desc`} className="table-overview__row__expanded">
          <td colSpan={6}>
            <div>
              <div>
                {description}

                <div className="table-overview__row__expanded__right table-overview__row__expanded__right--small">
                  <div>
                    <div>
                      <Goal />
                    </div>
                    <div>
                      <p className="table-overview__row__expanded__right__heading">
                        Doel
                      </p>
                      <span>{goals?.join(", ")}</span>
                    </div>
                  </div>

                  <div>
                    <div>
                      <Briefcase />
                    </div>
                    <div>
                      <p className="table-overview__row__expanded__right__heading">
                        Leergebied
                      </p>
                      <span>{learning_areas?.join(", ")}</span>
                    </div>
                  </div>
                  <div>
                    <div>
                      <User />
                    </div>
                    <div>
                      <p className="table-overview__row__expanded__right__heading">
                        Sleutelcompetentie
                      </p>
                      <span>{key_competencies?.join(", ")}</span>
                    </div>
                  </div>
                </div>

                <div className="download-container tussendoortjes-cta">
                  {cta_link && (
                    <Button
                      text={`Bekijk`}
                      onClick={() => {
                        window.open(addProtocolToUrl(cta_link));
                      }}
                    />
                  )}
                </div>
              </div>
              <div className="table-overview__row__expanded__right">
                <div>
                  <div>
                    <Goal />
                  </div>
                  <div>
                    <p className="table-overview__row__expanded__right__heading">
                      Doel
                    </p>
                    <span>{goals?.join(", ")}</span>
                  </div>
                </div>

                <div>
                  <div>
                    <Briefcase />
                  </div>
                  <div>
                    <p className="table-overview__row__expanded__right__heading">
                      Leergebied
                    </p>
                    <span>{learning_areas?.join(", ")}</span>
                  </div>
                </div>
                <div>
                  <div>
                    <User />
                  </div>
                  <div>
                    <p className="table-overview__row__expanded__right__heading">
                      Sleutelcompetentie
                    </p>
                    <span>{key_competencies?.join(", ")}</span>
                  </div>
                </div>
              </div>
            </div>
          </td>
        </tr>
      )}
    </>
  );
};
